import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { setToken } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ArrowLeft, Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "tania@clinicamendoza.mx", password: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", form);
      setToken(r.data.token);
      toast.success(`Bienvenida, ${r.data.user.name}`);
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F0EB] px-6" data-testid="admin-login-page">
      <div className="absolute top-6 left-6">
        <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#5C5E5C] hover:text-[#A69076]" data-testid="login-back-link">
          <ArrowLeft className="w-4 h-4" /> Volver al sitio
        </Link>
      </div>
      <form onSubmit={onSubmit} className="w-full max-w-md bg-white rounded-2xl border border-[#E6E2DC] p-10 shadow-sm" data-testid="admin-login-form">
        <div className="w-12 h-12 rounded-full bg-[#1A1C1A] flex items-center justify-center mb-7">
          <Lock className="w-5 h-5 text-[#D9CDBC]" />
        </div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#A69076] mb-2">— Panel privado</div>
        <h1 className="font-display text-3xl text-[#1A1C1A] mb-7">Acceso administrativo</h1>
        <div className="space-y-5">
          <div>
            <Label className="text-[11px] tracking-[0.2em] uppercase text-[#5C5E5C] font-normal mb-2 block">Correo</Label>
            <Input data-testid="login-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
          </div>
          <div>
            <Label className="text-[11px] tracking-[0.2em] uppercase text-[#5C5E5C] font-normal mb-2 block">Contraseña</Label>
            <Input type="password" data-testid="login-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
          </div>
        </div>
        <Button type="submit" disabled={loading} className="w-full mt-8 rounded-full bg-[#1A1C1A] hover:bg-[#A69076] text-white h-12 text-xs uppercase tracking-[0.2em]" data-testid="login-submit">
          {loading ? "Ingresando..." : "Iniciar sesión"}
        </Button>
      </form>
    </div>
  );
}
